module.exports = __webpack_public_path__ + "media/aibo.c40e7b35.mp4";